import { z } from 'zod';

export const schema = z.object({
    type: z.enum(['5', '4', '3', '2', '1']).optional(),
});

export const options = [
    {
        value: '5',
        label: 'Very Satisfied',
        image: 'heart_eyes.svg',
    },
    {
        value: '4',
        label: 'Satisfied',
        image: 'smiling_face.svg',
    },
    {
        value: '3',
        label: 'Neutral',
        image: 'without_mouth.svg',
    },
    {
        value: '2',
        label: 'Unsatisfied',
        image: 'confused_face.svg',
    },
    {
        value: '1',
        label: 'Very Unsatisfied',
        image: 'angry_face.svg',
    },  
];
